import React from 'react';

/**
 * SMS Consent checkbox - checked by default (opt-out model)
 * Simple, layman-friendly language with link to full terms
 */
export default function SMSConsent({
  checked = true,
  onChange,
  companyName = 'this business',
  style = {}
}) {
  return (
    <label style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '0.75rem',
      cursor: 'pointer',
      fontSize: '0.9rem',
      color: '#b0b0b0',
      padding: '0.75rem',
      background: '#2a2a2a',
      borderRadius: '8px',
      border: '1px solid #3a3a3a',
      ...style
    }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          width: '20px',
          height: '20px',
          marginTop: '2px',
          accentColor: '#F05A28',
          cursor: 'pointer',
          flexShrink: 0
        }}
      />
      <span>
        I agree to receive texts from <strong style={{ color: '#e0e0e0' }}>{companyName}</strong> about
        my appointments, quotes, and invoices.
        <a
          href="/sms-terms.html"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{
            color: '#F05A28',
            marginLeft: '4px',
            textDecoration: 'none'
          }}
        >
          Terms & opt-out info
        </a>
      </span>
    </label>
  );
}

/**
 * Inline version for tighter spaces
 */
export function SMSConsentInline({
  checked = true,
  onChange,
  companyName = 'this business'
}) {
  return (
    <label style={{
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
      cursor: 'pointer',
      fontSize: '0.85rem',
      color: '#888'
    }}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        style={{
          width: '16px',
          height: '16px',
          accentColor: '#F05A28',
          cursor: 'pointer'
        }}
      />
      <span>
        OK to text me about my service.{' '}
        <a
          href="/sms-terms.html"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
          style={{ color: '#F05A28', textDecoration: 'none' }}
        >
          Terms
        </a>
      </span>
    </label>
  );
}
